module.exports = __webpack_public_path__ + "24e004ab/img/copy-icon.408fdb2d.svg";